import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination-manager',
  templateUrl: './pagination-manager.component.html',
  styleUrls: ['./pagination-manager.component.css']
})
export class PaginationManagerComponent {
  @Input() id: string;
  @Input() autohide = true;
  @Input() directionLinks = true;
  @Output() pageChange = new EventEmitter();

  onPageChange(event) {
    this.pageChange.emit(event);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/managers/pagination-manager/pagination-manager.component.ts